import { FaCarSide, FaTools } from "react-icons/fa";

const About = {
    sub: "About Us",
    heading: "Driving Your Dreams with Premium Cars",
    description: "Welcome to our dealership, where we provide top-quality vehicles and outstanding services to meet all your driving needs. Explore a wide selection of cars and experience the best in customer care.",
    experience: {
        years: "30+ years",
        text: "driving excellence"
    },
    points: [
        { icon: <FaCarSide />, title: "Wide Vehicle Range", content: "Discover new and pre-owned cars, SUVs, and trucks to suit your lifestyle and budget." },
        { icon: <FaTools />, title: "Reliable Maintenance", content: "Our expert mechanics ensure your vehicle stays in top condition with professional care." }
    ],
    button: {
        text: "Learn More",
        link: 'About-us'
    }
};

export default About;